import { Layout } from "./components/Layout";
import { ConfigProvider } from "./hooks/useConfig";
import { AirdropPage } from "./pages/airdrop/AirdropPage";
import { FaqPage } from "./pages/faq/FaqPage";
import { HomePage } from "./pages/home/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { TermsPage } from "./pages/terms/TermsPage";
import { RouterProvider, useRouter } from "./router/router";

/** Normalises a trailing slash so /faq and /faq/ resolve to the same route. */
const normalise = (path: string): string =>
  path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;

function Routes() {
  const { path } = useRouter();
  switch (normalise(path)) {
    case "/":
      return <HomePage />;
    case "/airdrop":
      return <AirdropPage />;
    case "/faq":
      return <FaqPage />;
    case "/terms":
      return <TermsPage />;
    default:
      return <NotFoundPage />;
  }
}

export function App() {
  return (
    <ConfigProvider>
      <RouterProvider>
        <Layout>
          <Routes />
        </Layout>
      </RouterProvider>
    </ConfigProvider>
  );
}
